import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { AddToFavoritesRequest, AddToFavoritesResponse } from 'src/types/favorite';
import axiosInstance from 'src/utils/axios';

async function addToFavorites(request: AddToFavoritesRequest): Promise<AddToFavoritesResponse> {
  const res = await axiosInstance.post<AddToFavoritesResponse>(api.addToFavorites, request);
  return res.data;
}

const useAddToFavoritesMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) => {
  const mutation = useMutation({
    mutationFn: addToFavorites,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error as Error);
    },
  });

  return mutation;
};

export default useAddToFavoritesMutation;
